module.exports = __webpack_public_path__ + "static/media/tip-two.e86f943e.png";